<template>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div v-else>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">팝업관리</span>
            <span class="txt">센터 admin, 회원 app, 관리자 app 등에 보여질 팝업 게시글을 관리합니다.</span>
        </div>
        <loading-spinner v-if="!popupDetail"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/popup/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/popup/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deletePopup(popupDetail.id)">
                        삭제
                    </button>
                </div>
            </div>
            <table class="com-table view">
                <colgroup>
                    <col style="width: 170px" />
                    <col style="width: auto" />
                    <col style="width: 170px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td>{{ popupDetail.boardCategory === null ? '' : popupDetail.boardCategory.name }}</td>
                        <th>글쓴이</th>
                        <td>{{ popupDetail.info.createdName }}</td>
                    </tr>
                    <tr>
                        <th>노출대상</th>
                        <td v-html="showType"></td>
                        <th>조회수</th>
                        <td>{{ popupDetail.viewCount }}</td>
                    </tr>
                    <tr>
                        <th>첨부파일</th>
                        <td>
                            <a v-for="file in fileList" :href="file.fileUrl" class="file-down" style="cursor: pointer">
                                {{ file.name }}
                            </a>
                        </td>
                        <th>등록일</th>
                        <td>{{ popupDetail.info.createdAt | timestampFilter }}</td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">{{ popupDetail.title }}</td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="popupDetail.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/popup/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/popup/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deletePopup(popupDetail.id)">
                        삭제
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'popupDetail',
    components: { LoadingSpinner },
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.fetchPopupDetail();
    },
    data() {
        return {
            careAuth: false,
            isLoading: false,
            id: this.$route.params.id,
            popupDetail: null,
            showTypeList: [
                '센터+회원 전체 <small>(센터 admin, 센터 app, 회원 app 전체 공지사항에 노출됩니다.)</small>',
                '센터 전체 <small>(센터 admin, 센터 app 모든 센터 공지사항에 노출됩니다.)</small>',
                '센터 개별 <small>(센터 admin, 센터 app 선택한 1개의 센터 공지사항에 노출됩니다.)</small>',
                '회원 <small>(회원 app전체 공지사항에 노출됩니다.)</small>',
            ], // 노출대상
            showTypeValueList: ['T', 'C', 'A', 'B'], // 노출대상 Value 목록
            fileList: null,
            showType: '',
        };
    },
    methods: {
        // 팝업 상세 Fetch
        async fetchPopupDetail() {
            try {
                const { data } = await this.getPopupDetail(this.id);
                this.popupDetail = data;
                console.log(data);
                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getPopupDetailFileGroup(data.fileGroupId);
                    this.fileList = fileGroupData.data;
                }

                this.showTypeValueList.forEach((showType, index) => {
                    // 노출대상 찾기
                    if (showType === this.popupDetail.showType) {
                        this.showType = this.showTypeList[index];
                    }
                });

                console.log('===> Success Loading Popup Detail', data);
            } catch (error) {
                console.log(error);
            }
        },

        // 팝업 삭제
        async deletePopup(id) {
            try {
                this.isLoading = true;
                const { data } = await this.getDeletePopup(id);
                alert('팝업을 삭제했습니다.');
                this.isLoading = false;
                console.log('===> Success Popup Delete', data);
                this.$router.push({ name: 'popupList' });
            } catch (error) {
                console.log(error);
            }
        },

        // 팝업 상세 API
        getPopupDetail(id) {
            return api.get(`/admin/api/board/popup/${id}/view`);
        },

        // 팝업 상세 첨부 파일 리스트 API
        getPopupDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 팝업 삭제 API
        getDeletePopup(id) {
            return api.delete(`/admin/api/board/popup/${id}`);
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then(function (response) {
                    let blob = new Blob([response.data], { type: 'image/png' });

                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style scoped src="@/assets/js/ckeditor/ckeditor.css"></style>
<!-- ckeditor5 css -->
<style lang="scss"></style>
